import script from "./FooterPartners.vue?vue&type=script&lang=ts&setup=true"
export * from "./FooterPartners.vue?vue&type=script&lang=ts&setup=true"

import "./FooterPartners.vue?vue&type=style&index=0&id=e7d795ea&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7d795ea"]])

export default __exports__